import { render, staticRenderFns } from "./TicketTransferMenu.vue?vue&type=template&id=6ed1ec17&"
import script from "./TicketTransferMenu.vue?vue&type=script&lang=js&"
export * from "./TicketTransferMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports